import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IdataBinding } from '@ispm-client/modules/aggregator/interfaces';
import { get, uniq, find, isEmpty } from 'lodash';
import { Observable, zip } from 'rxjs';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import * as immutable from 'immutable';
import { map } from 'rxjs/operators';

@Injectable()
export class FlattenService {
  private allDatabindings = { };
  private temDatabindings: Array<IdataBinding>;
  private formConfigs: Array<IdynamicFormItem>;
  private updatedFormData: Array<any> = [];
  private nonwidgetData: Array<any> = [];
  private nonwidgetDataObject = { };
  constructor(private store: Store<IgenomicsState>) {
  }

  public flatten(formIdOrFormConfig: any, formData: any, updatedFields: Array<string>, isAllFieldsUpadted = false): Observable<any> {
    const responseFlattenedArray: Array<any> = [];
    let formId = '';
    let formConfigs = [];
    if (typeof formIdOrFormConfig === 'string') {
      formId = formIdOrFormConfig;
    } else {
      formConfigs = formIdOrFormConfig;
    }

    if (updatedFields.length || isAllFieldsUpadted) {
      Object.keys(formData).forEach(identifier => {
        const formDataItems = formData[identifier];
        this.updatedFormData = [];
        this.recursiveFormData(formId, identifier, formDataItems, true, false, formConfigs);
        if (this.updatedFormData.length) {
          responseFlattenedArray.push({ formData: this.updatedFormData, formId: formId});
        }
      });
      if (!isEmpty(this.nonwidgetDataObject)) {
        const hiddenItemFlag: boolean = this.checkHiddenItems(this.nonwidgetDataObject);
        if (hiddenItemFlag) {
          this.nonwidgetData.push(this.nonwidgetDataObject);
          responseFlattenedArray.push({ formData: this.nonwidgetData, formId: formId});
        }
      }
    }
    this.nonwidgetData = [];
    this.nonwidgetDataObject = { };
    return Observable.of(responseFlattenedArray);
  }

  public recursiveFormData(formId, identifier, formDataItems, firstIteration, isWidget, formConfigs?) {
    let temDatabinding = { };
    let formConfigItem = { };
    let duplicateIdentifierItem: any = { };
    if(formId) {
      // Retrieve dataBindings from store
      this.getFormDataBindings(formId).subscribe((dataBindings) => {
        this.temDatabindings = [];
        this.temDatabindings = dataBindings;
      })
      // Retrieve formConfigs from store
      this.getStoredFormById(formId).subscribe((configs) => {
        this.formConfigs = [];
        this.formConfigs = configs;
      });
    }
    else{
      this.formConfigs = formConfigs;
    }
    if (this.temDatabindings) {
      temDatabinding = this.temDatabindings.find(function (obj) {
        return obj['_dataBindingIdentifier'] === identifier;
      });
    }
    if (this.formConfigs) {
      formConfigItem = this.formConfigs.find(function (obj) {
        return obj['name'] === identifier || obj['name'] === '#'+identifier;
      });
    }
    const formConfigType: string = get(formConfigItem, ['type']) ? (get(formConfigItem, ['type']).toLowerCase()) : '';
    if (get(temDatabinding, ['isFlatten']) || (formConfigType === 'widget') || (isWidget)) {
      if (Array.isArray(formDataItems)) {
        for (const item of uniq(formDataItems)) {
          let tempFormId = item['formId'];
          tempFormId = tempFormId ? tempFormId : formId;
          this.recursiveFormData(tempFormId, identifier, item, false, true);
        }
      }
      else if (typeof formDataItems === 'object') {
        Object.keys(formDataItems).forEach(key => {
          this.recursiveFormData(formId, key, formDataItems[key], false, false);
        });
        Object.keys(formDataItems).forEach(key => {
          duplicateIdentifierItem = find(this.updatedFormData, function(obj) {
            return obj['_dataBindingIdentifier'] === key;
          });
          if (duplicateIdentifierItem) {
            delete formDataItems[key];
          }
        });
        if (!isEmpty(formDataItems)) {
          const hiddenItemFlag: boolean = this.checkHiddenItems(formDataItems);
          if (hiddenItemFlag) {
            formDataItems['_dataBindingIdentifier'] = identifier;
            this.updatedFormData.push(formDataItems);
          }
        }
      }
    }
    else if (firstIteration) {
      if (!isEmpty(formDataItems)) {
        const obj = { };
        obj[identifier] = formDataItems;
        this.nonwidgetDataObject = Object.assign(this.nonwidgetDataObject, obj);
      }
    }
  }

  public getStoredFormConfigs(): Store<immutable.Map<string, IdynamicFormItem[]>> {
    return this.store.select('forms', 'configs') as any;
  }

  public getStoredFormById(formId: string) {
    return this.getStoredFormConfigs().pipe(
      map(forms => forms.get(formId))
    );
  }

  public checkHiddenItems(data: any): boolean {
    let formDataItemCounter: number = 0;
    let hiddenItemCounter: number = 0;
    // Logic to remove extra data. This will be updated once we have attribute in formConfig
    Object.keys(data).forEach(key => {
      const formConfigItem = find(this.formConfigs, function(obj) {
        return obj['name'] === key;
      });
      if (get(formConfigItem, 'type') === 'hidden') {
        hiddenItemCounter++;
      }
      formDataItemCounter++;
    });
    const hiddenItemFlag: boolean = (formDataItemCounter != hiddenItemCounter) ? true  : false;
    return hiddenItemFlag;
  }

// TODO remove duplicate
public flattenProper(formIdOrFormConfig: any, formData: any, updatedFields: Array<string>, isAllFieldsUpadted = false): Observable<any> {
  const responseFlattenedArray: Array<any> = [];
  let formId = '';
  let formConfigs = [];
  if (typeof formIdOrFormConfig === 'string') {
    formId = formIdOrFormConfig;
  } else {
    formConfigs = formIdOrFormConfig;
  }

  if ((updatedFields.length) || isAllFieldsUpadted) {
    Object.keys(formData).forEach(identifier => {
      const formDataItems = formData[identifier];
      this.updatedFormData = [];
      this.recursiveFormDataProcessing(formId, identifier, formDataItems, true, false, formConfigs, formData['emptySave']);
      if (this.updatedFormData.length) {
        responseFlattenedArray.push({ formData: this.updatedFormData, formId: formId});
      }
    });
    if (!isEmpty(this.nonwidgetDataObject)) {
      const hiddenItemFlag: boolean = this.checkHiddenItems(this.nonwidgetDataObject);
      if (hiddenItemFlag) {
        this.nonwidgetData.push(this.nonwidgetDataObject);
        responseFlattenedArray.push({ formData: this.nonwidgetData, formId: formId});
      }
    }
  }
  this.nonwidgetData = [];
  this.nonwidgetDataObject = { };
  return Observable.of(responseFlattenedArray);
}

private recursiveFormDataProcessing(formId: string, identifier: string, formDataItems, firstIteration: boolean,
                                    isWidget: boolean, formConfigs?: IdynamicFormItem[], emptySave:boolean = false) {

  if (formConfigs) {
    this.formConfigs = formConfigs;
    this.flattenServiceData(formId, identifier, formDataItems, firstIteration, isWidget, emptySave);
  }
  else if (formId) {
    zip(this.getFormConfig(formId), this.getFormDataBindings(formId)).
    subscribe((configs) => {
      this.formConfigs = configs[0];
      this.temDatabindings = configs[1];
      this.flattenServiceData(formId, identifier, formDataItems, firstIteration, isWidget, emptySave);
    });
  }
}

private flattenServiceData(formId: string, identifier: string, formDataItems, firstIteration: boolean, isWidget: boolean, emptySave:boolean = false) {
  let temDatabinding = { };
  let formConfigItem = { };
  let duplicateIdentifierItem: any = { };
  if (this.temDatabindings) {
    temDatabinding = this.temDatabindings.find(function (obj) {
      return obj['_dataBindingIdentifier'] === identifier;
    });
  }
  if (this.formConfigs) {
    formConfigItem = this.formConfigs.find(function (obj) {
      return obj['name'] === identifier;
    });
  }
  const formConfigType: string = get(formConfigItem, ['type']) ? (get(formConfigItem, ['type']).toLowerCase()) : '';
  if (get(temDatabinding, ['isFlatten']) || (formConfigType === 'widget') || (isWidget)) {
    if (Array.isArray(formDataItems)) {
      for (const item of uniq(formDataItems)) {
        let tempFormId = item['formId'];
        tempFormId = tempFormId ? tempFormId : formId;
        this.recursiveFormDataProcessing(tempFormId, identifier, item, false, true, [], emptySave);
      }
    }
    else if (typeof formDataItems === 'object') {
      Object.keys(formDataItems).forEach(key => {
        this.recursiveFormDataProcessing(formId, key, formDataItems[key], false, false, [], emptySave);
      });
      Object.keys(formDataItems).forEach(key => {
        duplicateIdentifierItem = find(this.updatedFormData, function(obj) {
          return obj['_dataBindingIdentifier'] === key;
        });
        if (duplicateIdentifierItem) {
          delete formDataItems[key];
        }
      });
      if (!isEmpty(formDataItems)) {
        const hiddenItemFlag: boolean = this.checkHiddenItems(formDataItems);
        if (hiddenItemFlag) {
          formDataItems['_dataBindingIdentifier'] = identifier;
          this.updatedFormData.push(formDataItems);
        }
      }
    }
  }
  else if (firstIteration) {
    if (!isEmpty(formDataItems)) {
      const obj = { };
      obj[identifier] = formDataItems;
      this.nonwidgetDataObject = Object.assign(this.nonwidgetDataObject, obj);
    }
  else if(emptySave){
        const obj = { };
        obj[identifier] = formDataItems;
        this.nonwidgetDataObject = Object.assign(this.nonwidgetDataObject, obj);
      }
  }
}

public getFormConfig(formId: string): Observable<IdynamicFormItem[]> {
  return this.store.select('forms', 'configs').take(1).map(forms => forms.get(formId));
}

public getFormDataBindings(formId: string): Observable<IdataBinding[]> {
  return this.store.select('forms', 'dataBindings').take(1).map(forms => forms.get(formId));
}
}

